module.exports = __webpack_public_path__ + "media/fresh/financial-aid-hero-d82674a9.jpg";